import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import { Container } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { UserOnbording as SELECT_URL } from 'Components/Api/PaysprintAccountOpeningAPI';
import HOCLoader from 'Components/Loader/HOCLoader';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';

const CustomContainer = HOCLoader(Container);

export const UserOnbording = () => {
    const history = useHistory();

    const formRef = useRef();

    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [URL, setURL] = useState('');
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [Message, setMessage] = useState('');
    const [status, setStatus] = useState('PROCESS');
    const selectURL = async () => {
        setSeverity('error');
        setResponseMessage('');
        setIsError(false);

        const response = await SELECT_URL();

        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);

            setStatus('FAILURE');
            setMessage(response.data);
            setIsAlertErrorOpen(true);
            return;
        }
        var data = JSON.parse(response.data);

        if (data.Status === 'FAILURE') {
            if (data.Message === 'User already onboarded') {
                history.push('/PS_AccountOpen');
                return;
            }

            setSeverity('error');
            setResponseMessage(data.Message);
            setIsError(true);

            setStatus(data.Status);
            setMessage(data.Message);
            setIsAlertErrorOpen(true);

            return;
        }
        setSeverity('success');
        setURL(data.Redirecturl);
        formRef.current.submit();
    };

    useEffect(() => {
        selectURL();
    }, []);

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <form ref={formRef} method="post" action={URL} target="_blank">
                <input
                    type="submit"
                    value="Redirect"
                    style={{ display: 'none' }}
                />
            </form>

            {isAlertErrorOpen ? (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
